<script lang="ts" setup>
useHead({ title: 'Política de Privacidad' })
</script>

<template>
  <div class="mx-auto prose px-4 text-xl">
    <h1 id="pol-tica-de-privacidad-de-promotora">
      Política de privacidad de TICKETSMART.PE
    </h1>
    <h2 id="introducci-n">Introducción</h2>
    <p>
      <strong>TICKETSMART S.A.C.</strong>, identificado con RUC Nº 20614443228,
      con domicilio en Cal. Paul Harris Nº 1760, distrito de La Victoria, de la
      ciudad de Chiclayo a través de su página web TICKETSMART.PE (en adelante,
      “TICKETSMART.PE”), recoge en este documento su Política de Privacidad.
    </p>
    <p>
      <strong>TICKETSMART S.A.C.</strong> asegura la máxima reserva y protección
      de aquellos datos de carácter personal que los usuarios o potenciales
      usuarios nos proporcionen mediante nuestro sitio Web
      <a href="https://ticketsmart.pe/">https://ticketsmart.pe/</a> y otros
      documentos o formularios, con la finalidad de hacer uso de los servicios.
    </p>
    <h2 id="objetivo-y-finalidad">Objetivo y finalidad</h2>
    <p>
      <strong>TICKETSMART.PE</strong> es consciente de la elevada importancia
      que tiene la privacidad de nuestros clientes y de todas aquellas personas
      que se interesan por los eventos ofrecidos. Siendo consecuentes con esta
      consideración, tenemos el compromiso de respetar su privacidad y proteger
      la confidencialidad de su información privada y datos personales. Por tal
      motivo, mediante la presente Política de Privacidad, damos a conocer a
      nuestros usuarios, la manera en que se recogen, tratan y se protegen los
      datos personales brindados en <strong>TICKETSMART.PE</strong>.
    </p>
    <p>
      La información personal privada no incluye información que está disponible
      a través de fuentes accesibles al público. Se entiende por tales los
      medios de comunicación electrónica, óptica y de otra tecnología concebidos
      para facilitar información al público y abiertos a la consulta general,
      las guías telefónicas, los diarios y revistas, los medios de comunicación
      social, las listas profesionales, los repertorios de jurisprudencia
      anonimizados, los Registros Públicos administrados por la Superintendencia
      Nacional de Registros Públicos así como todo otro registro o banco de
      datos calificado como público conforme a ley, las entidades de la
      Administración Pública en relación a la información que deba ser entregada
      en aplicación de la Ley Nº 27806, Ley de Transparencia y Acceso a la
      Información Pública.
    </p>
    <h2 id="legislaci-n">Legislación</h2>
    <p>
      De acuerdo con la Ley N° 29733 – Ley de Protección de Datos Personales (en
      adelante, la “Ley”) y su Reglamento, aprobado por el Decreto Supremo No.
      003-2013-JUS, se entiende por datos personales toda información sobre una
      persona natural que la identifica o hace identificable a través de medios
      que pueden ser razonablemente utilizados.
    </p>
    <p>
      Por otro lado, por tratamiento de datos personales se entiende como
      cualquier operación o procedimiento técnico, automatizado o no, que
      permite la recopilación, registro, organización, almacenamiento,
      conservación, elaboración, modificación, extracción, consulta,
      utilización, bloqueo, supresión, comunicación por transferencia o por
      difusión o cualquier otra forma de procesamiento que facilite el acceso,
      correlación o interconexión de los datos personales.
    </p>
    <p>
      TICKETSMART.PE desarrolla su política de tratamiento de datos personales
      en atención a los principios rectores establecidos en la Ley mencionados a
      continuación:
    </p>
    <ol>
      <li>
        <strong>Principio de legalidad</strong>: se rechaza la recopilación de
        los datos personales de nuestros usuarios por medios fraudulentos,
        desleales o ilícitos.
      </li>
      <li>
        <strong>Principio de consentimiento</strong>: en el tratamiento de los
        datos personales de nuestros usuarios mediará su consentimiento.
      </li>
      <li>
        <strong>Principio de finalidad</strong>: Los datos personales de
        nuestros usuarios se recopilarán para una finalidad determinada,
        explícita y lícita, y no se extenderá a otra finalidad que no haya sido
        la establecida de manera inequívoca como tal al momento de su
        recopilación.
      </li>
      <li>
        <strong>Principio de proporcionalidad</strong>: todo tratamiento de
        datos personales de nuestros usuarios será adecuado, relevante y no
        excesivo a la finalidad para la que estos hubiesen sido recopilados.
      </li>
      <li>
        <strong>Principio de calidad</strong>: Los datos personales serán
        veraces, exactos y, en lo posible, actualizados, necesarios, pertinentes
        y adecuados respecto de la finalidad para la que fueron recopilados.
      </li>
      <li>
        <strong>Principio de seguridad</strong>: se conservarán de forma tal que
        se garantice su seguridad y solo por el tiempo necesario para cumplir
        con la finalidad del tratamiento.
      </li>
    </ol>
    <p>
      <strong>TICKETSMART.PE</strong> y, en su caso, los encargados de
      tratamiento, cuentan con las medidas de seguridad apropiadas y acordes con
      el tratamiento que se vaya a efectuar, así como adoptarán las medidas
      técnicas, organizativas y legales necesarias para garantizar
      confidencialidad de los datos personales.
    </p>
    <h2 id="informaci-n-sobre-datos-personales">
      Información sobre datos personales
    </h2>
    <p>
      El usuario queda informado y autoriza libre y voluntariamente a
      <strong>TICKETSMART.PE</strong> para recolectar, almacenar, conservar,
      acceder, usar, suprimir o actualizar sus Datos Personales para sus
      actividades en el Perú. En ese sentido, los datos personales a los que
      <strong>TICKETSMART.PE</strong> tenga acceso como consecuencia de los
      servicios que brinda o mediante el llenado de diferentes formularios, se
      incorporarán al correspondiente “Banco de Datos Personales de Usuarios
      Web”, conformando el conjunto organizado de datos personales de usuarios,
      creado por <strong>TICKETSMART.PE</strong> y registrado en el Registro
      Nacional de Protección de Datos Personales.
    </p>
    <p>
      Los datos personales facilitados por los usuarios serán tratados con total
      confidencialidad y sólo podrán ser conocidos y manejados por el personal
      de <strong>TICKETSMART.PE</strong>, los proveedores y organizadores de
      este que necesiten conocer dicha información para brindar los servicios
      ofrecidos. <strong>TICKETSMART.PE</strong> se compromete a guardar secreto
      profesional respecto de los mismos y garantiza el deber de guardarlos
      adoptando todas las medidas de seguridad necesarias. No será necesaria la
      autorización cuando los datos personales sean necesarios para la ejecución
      de una relación contractual en la que el Titular de Datos Personales sea
      parte.
    </p>
    <p>
      Si los datos registrados resultaran inexactos, en todo o en parte, o
      incompletos, <strong>TICKETSMART.PE</strong> podrá actualizarlos y/o
      sustituirlos por los correspondientes datos rectificados o completados.
    </p>
    <p>
      Los datos personales solicitados a los usuarios mediante diferentes
      formularios del sitio Web, son datos básicos de contacto y son adecuados,
      pertinentes y no excesivos en relación con la finalidad para los que se
      recogen.
    </p>
    <h2 id="finalidad-del-tratamiento-de-los-datos-personales">
      Finalidad del tratamiento de los datos personales
    </h2>
    <p>
      El usuario autoriza expresamente a TICKETSMART.PE al uso de sus datos para
      procesar compras, brindar servicios, procesar pagos, generar estadísticas,
      mantener y actualizar nuestros archivos y sus cuentas con nosotros, hacer
      disponible contenido tales como listas de deseos y comentarios de los
      clientes, recomendaciones de productos y servicios de interés para usted.
      Asimismo, utilizamos esta información para poder brindar estos servicios y
      funciones en nuestro propio nombre o por parte de terceros, para mejorar
      nuestros servicios, características y plataforma, prevenir o detectar
      fraude o abuso, permitir a terceros prestar servicios técnicos, logístico
      o de otro tipo en nuestro nombre, adaptar nuestras comunicaciones y, en
      general, desarrollo de acciones comerciales, contractuales, marketing,
      publicitarias, promocionales, administrativas y para el soporte a
      usuarios, sean de carácter general o adaptado a sus características
      personales. Dichas acciones podrán ser realizadas por correo electrónico u
      otro medio de comunicación equivalente.
    </p>
    <p>
      Los datos personales serán cancelados cuando hayan dejado de ser
      necesarios para las finalidades para las cuales han sido recogidos. Sin
      embargo, se conservarán durante el tiempo en qué pueda exigirse algún tipo
      de responsabilidad a TICKETSMART.PE derivada de esta relación con los
      usuarios. No se considerará incompatible el tratamiento posterior con
      fines históricos, estadísticos o científicos.
    </p>
    <p>
      En caso el Usuario no desee recibir las comunicaciones comerciales
      señaladas, podrá comunicarlo en cualquier momento al correo:
      contacto@ticketsmart.pe
    </p>
    <h2 id="fines-promocionales">Fines promocionales</h2>
    <p>
      Mediante su aceptación usted autoriza a <strong>TICKETSMART.PE</strong> a
      tratar sus datos personales proporcionados en la presente operación y/o
      formulario para enviarle información sobre promociones, descuentos,
      conocer sus preferencias de consumo, realizar encuestas, envío de próximos
      eventos, nuevos productos, promociones, ofertas, novedades y en general
      cualquier fin promocional. Sus datos personales serán tratados conforme a
      la presente Política de Privacidad y quedarán almacenados en el Banco de
      Datos Personales de Usuarios Web de
      <strong>TICKETSMART.PE</strong> durante el tiempo necesario para cumplir
      con la finalidad del tratamiento.
    </p>
    <h2 id="libro-de-reclamaciones">Libro de Reclamaciones</h2>
    <p>
      Asimismo, el usuario autoriza expresamente a
      <strong>TICKETSMART.PE</strong> a que, cuando haga uso del formulario
      virtual que se encuentra en el URL
      <a href="https://ticketsmart.pe/libro-reclamaciones"
        >https://ticketsmart.pe/libro-reclamaciones</a
      >, sus datos sean tratados con la finalidad de atender las necesidades
      propias del procedimiento de atención de los reclamos que presenten los
      usuarios a través del Libro de Reclamaciones, así como para, una vez
      culminado el procedimiento de atención del reclamo, atender las
      necesidades derivadas de cualquier proceso o procedimiento judicial,
      administrativo o arbitral que a futuro se derive o surja en relación con
      el reclamo que el usuario haya presentado, atender cualquier fiscalización
      de la autoridad competente en materia de tratamiento de datos personales.
    </p>
    <p>
      Los datos recopilados a través del Libro de Reclamaciones se almacenarán
      en el banco de datos de Usuarios Web de titularidad de
      <strong>TICKETSMART.PE</strong>.
    </p>
    <p>
      Como consecuencia de las finalidades descritas, el plazo de almacenamiento
      de los datos será de forma indefinida. Para todo efecto, se entenderá que
      este plazo máximo de almacenamiento y de tratamiento de los datos
      personales es un derecho de <strong>TICKETSMART.PE</strong> y no una
      obligación, por lo que <strong>TICKETSMART.PE</strong> podrá optar por
      almacenarlos y/o tratarlos por plazos menores. Esto no perjudica en
      absoluto los derechos de los usuarios para revocar el consentimiento de
      sus datos personales en cualquier momento, conforme la Ley se lo permite y
      <strong>TICKETSMART.PE</strong> lo detalla en la presente Política de
      Privacidad.
    </p>
    <h2 id="transferencia-de-datos-personales-a-nivel-nacional-o-internacional">
      Transferencia de datos personales a nivel nacional o internacional
    </h2>
    <p>
      El usuario autoriza la transferencia de sus datos a las empresas a nivel
      nacional o internacional (flujo transfronterizo) relacionadas y/o
      asociadas a <strong>TICKETSMART.PE</strong> para poder gestionar
      adecuadamente los servicios solicitados por los usuarios y las gestiones
      que se deriven posteriormente, en relación a la finalidad indicada en los
      apartados anteriores, extendiendo para ello a éstas la autorización
      expresa para su uso. TICKETSMART.PE garantiza el nivel adecuado de
      protección de los datos personales de los usuarios para la transferencia
      de datos personales, de acuerdo a una protección equiparable a lo previsto
      por esta Ley o por los estándares internacionales en la materia.
    </p>
    <p>
      En tal sentido, los datos personales, así como la información que se
      genere a partir de ellos de acuerdo a los tratamientos de datos personales
      señalados en el numeral anterior, serán transferidos a las empresas que
      forman parte de los servicios de <strong>TICKETSMART.PE</strong>, con los
      cuales <strong>TICKETSMART.PE</strong> tiene una relación contractual para
      realizar la venta de productos o servicios, así como para incorporar los
      datos personales en su base de datos y realizar las finalidades señaladas
      el punto 5. anterior.
    </p>
    <p>
      <strong>TICKETSMART.PE</strong> utiliza servidores de terceros para el
      almacenamiento de bancos de datos por medios tecnológicos, por lo que se
      realizará flujo transfronterizo con las siguientes empresas: (i) Google
      Cloud, empresa prestadora de servicios de alojamiento web ubicada en Iowa,
      Estados Unidos de América; y (ii) Amazon EC”, empresa prestadora de
      servicios de alojamiento web ubicada en Ohio y Virginia del Norte, Estados
      Unidos de América.
    </p>
    <p>
      Estos datos personales también pueden ser comunicados a las entidades
      administrativas, autoridades judiciales y/o policiales, siempre y cuando
      esté establecido por Ley.
    </p>
    <h2 id="datos-proporcionados-a-organizadores">
      Datos proporcionados a organizadores
    </h2>
    <p>
      En ciertos eventos, los organizadores solicitan “datos adicionales” sin
      mediar el uso de la plataforma de <strong>TICKETSMART.PE</strong>, ya sea
      para brindar adecuadamente el servicio ofrecido, como para temas
      comerciales y de marketing. La naturaleza de dichos datos varía
      dependiendo del evento a realizar y <strong>TICKETSMART.PE</strong> no
      puede saber con anterioridad que información necesita cada organizador.
      (Por ejemplo, algunos eventos requieren conocer la edad del participante
      por venta de alcohol, los eventos deportivos requieren conocer la talla de
      vestimenta del participante para poder elaborar merchandising deportivo
      personalizado, algunos organizadores realizan encuestas de satisfacción o
      diversas preguntas a las participantes relacionadas a sus eventos, entre
      otros). En igual sentido, dada la naturaleza de nuestra plataforma,
      <strong>TICKETSMART.PE</strong> no se hace responsable por el tratamiento
      o finalidad que determine el organizador sobre los datos personales
      adicionales.
    </p>
    <h2 id="seguridad-de-los-datos-personales">
      Seguridad de los datos personales
    </h2>
    <p>
      En cumplimiento de la normativa vigente, la Directiva de Seguridad de la
      Información aprobada por la Resolución Directoral No. 019-2013-JUS/DGPDP
      de la Autoridad Nacional de Protección de Datos Personales,
      <strong>TICKETSMART.PE</strong> ha adoptado las medidas técnicas y
      organizativas de seguridad y confidencialidad apropiadas a la categoría de
      los datos personales, necesarias para mantener el nivel de seguridad
      requerido, con el objetivo de evitar en la medida de lo posible la
      alteración, pérdida o el tratamiento o acceso no autorizado que puedan
      afectar afecten a la integridad, confidencialidad y disponibilidad de la
      información.
    </p>
    <p>
      Sin embargo, la transmisión de información mediante las redes de
      comunicación y de Internet no es totalmente segura; por eso, y a pesar de
      que TICKETSMART.PE realizará sus mejores esfuerzos para proteger los datos
      personales, no podrá garantizar la seguridad de los mismos durante el
      tránsito hasta el sitio Web. Toda la información que los usuarios de
      Internet faciliten por este medio, se enviará por su cuenta y riesgo.
    </p>
    <h2
      id="ejercicio-de-los-derechos-de-acceso-rectificaci-n-cancelaci-n-y-oposici-n"
    >
      Ejercicio de los Derechos de Acceso, Rectificación, Cancelación y
      Oposición
    </h2>
    <p>
      Los Usuarios de Internet que hayan facilitado datos personales a
      <strong>TICKETSMART.PE</strong> pueden dirigirse a esta, con el fin de
      poder ejercer sus derechos de información, de acceso, de actualización,
      inclusión, rectificación y supresión, de impedir el suministro de sus
      datos personales, de oposición al tratamiento o de tratamiento objetivo de
      los datos, en los términos recogidos en la legislación vigente. Dichos
      derechos sólo podrán ser ejercidos por el titular de los datos personales
      o su apoderado, de conformidad con la ley.
    </p>
    <p>
      Para poder ejercer estos derechos, los usuarios deberán dirigirse a la
      siguiente dirección de correo electrónico contacto@ticketsmart.pe, con la
      referencia “Protección de Datos Personales”, especificando sus datos,
      acreditando su identidad y los motivos de su solicitud. Quien suscribe la
      solicitud deberá anexar copia simple de los documentos que acrediten la
      identidad del titular (Documento Nacional de Identidad o documento
      equivalente) o en su caso, la del apoderado, así como copia simple del
      poder otorgado por vía notarial cuando corresponda.
    </p>
    <p>
      Asimismo, <strong>TICKETSMART.PE</strong> informa a sus usuarios la
      existencia de la vía administrativa para hacer valer sus derechos a
      ejercitar ante la Autoridad Nacional de Protección de Datos o
      jurisdiccionales ante el Poder Judicial a los efectos de la
      correspondiente acción de habeas data.
    </p>
    <h2 id="otros">Otros</h2>
    <p>
      En tanto se trata de una herramienta de tipo virtual, que no permite el
      trato físico directo entre <strong>TICKETSMART.PE</strong> y el titular de
      los datos personales, <strong>TICKETSMART.PE</strong> recopilará y tratará
      los datos personales partiendo de la presunción de buena fe de que quien
      los facilita es mayor de edad ante la ley, es hábil en el idioma español,
      se encuentra en pleno uso de sus facultades mentales, ostenta plena
      capacidad civil y es titular de los datos personaleso actúa en calidad de
      representante del titular de los datos que facilita, en caso de que sean
      de titularidad de terceros.
    </p>
    <p>
      <strong>TICKETSMART.PE</strong> a través de su Sitio Web entiende la
      importancia de proteger la privacidad de los niños, especialmente en un
      entorno online. Por este motivo, el sitio Web no está diseñado ni dirigido
      a menores de edad. TICKETSMART.PE no llevará a cabo voluntariamente el
      tratamiento de datos personales relativos a menores de edad. En el
      supuesto que se tenga conocimiento que los datos personales recogidos
      corresponden a un menor de edad sin autorización, se adoptarán las medidas
      oportunas para eliminar estos datos tan pronto como sea posible.
    </p>
    <p>
      Para realizar cualquier tipo de consulta respecto a esta Política puede
      dirigirse a la siguiente dirección de correo electrónico:
      contacto@ticketsmart.pe
    </p>
    <h2
      id="vigencia-y-modificaci-n-de-la-presente-pol-tica-de-protecci-n-de-datos-personales"
    >
      Vigencia y modificación de la presente Política de Protección de Datos
      Personales
    </h2>
    <p>
      La Política de Protección de Datos Personales de TICKETSMART.PE es
      actualizada constantemente, por lo que TICKETSMART.PE se reserva el
      derecho a modificar su Política en el supuesto de que exista un cambio en
      la legislación vigente, doctrinal, jurisprudencial o por criterios propios
      empresariales. Si se introdujera algún cambio en esta Política, el nuevo
      texto se publicará en este mismo sitio Web.
    </p>
    <p>
      Se recomienda a todos los usuarios que accedan periódicamente a esta
      Política de Privacidad que encontraran en el sitio web
      <a href="https://ticketsmart.pe">https://ticketsmart.pe</a>
    </p>
  </div>
</template>
